import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SpinnerService {
  loadingSub: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public readonly loading$ = this.loadingSub.asObservable();

  constructor() {}

  showSpinner() {
    this.loadingSub.next(true);
  }

  hideSpinner() {
    this.loadingSub.next(false);
  }
}
